import React, { useState } from "react";
import TransparentButton from "component/misc/TransparentButton";
import { ChevronDown, ChevronUp } from "lucide-react";
import TransparentCard from "component/misc/TransparentCard";

const suppliers = [
  {
    name: "Thyssen krupp",
    location: "Germany",
    volume: "1.456.154mt",
    percentage: "23%",
    description:
      "ThyssenKrupp was formed in 1999 from the merger of two long-standing German industrial giants, Thyssen AG and Krupp Hoesch Stahl AG, both boasting over 200 years of history in steel and heavy industry.",
    details: {
      esgRating: "Germany",
      stockValue: "254",
      regulatory: "Eu/Germany",
      innovation: "High",
      topBuyer: "US, CH, UAE",
      stockValueSecond: "145€",
    },
  },
  {
    name: "Thyssen krupp",
    location: "Germany",
    volume: "1.456.154mt",
    percentage: "23%",
    description:
      "ThyssenKrupp was formed in 1999 from the merger of two long-standing German industrial giants, Thyssen AG and Krupp Hoesch Stahl AG, both boasting over 200 years of history in steel and heavy industry.",
    details: {
      esgRating: "Germany",
      stockValue: "254",
      regulatory: "Eu/Germany",
      innovation: "High",
      topBuyer: "US, CH, UAE",
      stockValueSecond: "145€",
    },
  },
  {
    name: "Thyssen krupp",
    location: "Germany",
    volume: "1.456.154mt",
    percentage: "23%",
    description:
      "ThyssenKrupp was formed in 1999 from the merger of two long-standing German industrial giants, Thyssen AG and Krupp Hoesch Stahl AG, both boasting over 200 years of history in steel and heavy industry.",
    details: {
      esgRating: "Germany",
      stockValue: "254",
      regulatory: "Eu/Germany",
      innovation: "High",
      topBuyer: "US, CH, UAE",
      stockValueSecond: "145€",
    },
  },
  {
    name: "Thyssen krupp",
    location: "Germany",
    volume: "1.456.154mt",
    percentage: "23%",
    description:
      "ThyssenKrupp was formed in 1999 from the merger of two long-standing German industrial giants, Thyssen AG and Krupp Hoesch Stahl AG, both boasting over 200 years of history in steel and heavy industry.",
    details: {
      esgRating: "Germany",
      stockValue: "254",
      regulatory: "Eu/Germany",
      innovation: "High",
      topBuyer: "US, CH, UAE",
      stockValueSecond: "145€",
    },
  },
];

const SupplierTab = () => {
  const [expanded, setExpanded] = useState(null);

  const toggleExpand = (index) => {
    setExpanded((prev) => (prev === index ? null : index));
  };

  return (
    <div className="supplier-tab-container">
      {/* Header */}
      <div className="supplier-tab-header">
        <span>Name</span>
        <span>Location</span>
        <span>Volume / year</span>
      </div>

      {/* Supplier Cards */}
      <div className="supplier-tab-list">
        {suppliers.map((supplier, index) => {
          const isExpanded = expanded === index;

          return (
            <TransparentCard
              key={index}
              padding={16}
              className="supplier-tab-card"
              onClick={() => toggleExpand(index)}
            >
              {/* Supplier Row */}
              <div className="supplier-tab-row">
                <span className="supplier-tab-name">{supplier.name}</span>

                <span className="supplier-tab-location">
                  {supplier.location}
                </span>

                <span className="supplier-tab-volume-text">
                  {supplier.volume}
                </span>

                <span className="supplier-tab-percentage">
                  {supplier.percentage}
                </span>

                <div className="supplier-tab-chevron">
                  {isExpanded ? (
                    <ChevronUp className="supplier-tab-chevron-icon" />
                  ) : (
                    <ChevronDown className="supplier-tab-chevron-icon" />
                  )}
                </div>
              </div>

              {/* Expanded Content */}
              {isExpanded && (
                <div className="supplier-tab-expanded">
                  <p className="supplier-tab-description">
                    {supplier.description}
                  </p>

                  {/* Details Table */}
                  <table className="supplier-tab-details-table">
                    <tbody>
                      <tr>
                        <td className="supplier-tab-detail-cell">
                          <div className="supplier-tab-detail-label">
                            ESG Rating
                          </div>
                          <div className="supplier-tab-detail-value">
                            {supplier.details.esgRating}
                          </div>
                        </td>
                        <td className="supplier-tab-detail-cell">
                          <div className="supplier-tab-detail-label">
                            Stock Value
                          </div>
                          <div className="supplier-tab-detail-value">
                            {supplier.details.stockValue}
                          </div>
                        </td>
                        <td className="supplier-tab-detail-cell">
                          <div className="supplier-tab-detail-label">
                            Regulatory
                          </div>
                          <div className="supplier-tab-detail-value">
                            {supplier.details.regulatory}
                          </div>
                        </td>
                        <td className="supplier-tab-detail-cell">
                          <div className="supplier-tab-detail-label">
                            Innovation
                          </div>
                          <div className="supplier-tab-detail-value">
                            {supplier.details.innovation}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="supplier-tab-detail-cell">
                          <div className="supplier-tab-detail-label">
                            Top Buyer
                          </div>
                          <div className="supplier-tab-detail-value">
                            {supplier.details.topBuyer}
                          </div>
                        </td>
                        <td className="supplier-tab-detail-cell">
                          <div className="supplier-tab-detail-label">
                            Stock Value
                          </div>
                          <div className="supplier-tab-detail-value">
                            {supplier.details.stockValueSecond}
                          </div>
                        </td>
                        <td className="supplier-tab-detail-cell">
                          <div className="supplier-tab-detail-label">-</div>
                          <div className="supplier-tab-detail-value">-</div>
                        </td>
                        <td className="supplier-tab-detail-cell">
                          <div className="supplier-tab-detail-label">-</div>
                          <div className="supplier-tab-detail-value">-</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="supplier-tab-profile-button">
                    <TransparentButton>Full Profile</TransparentButton>
                  </div>
                </div>
              )}
            </TransparentCard>
          );
        })}
      </div>
    </div>
  );
};

export default SupplierTab;
